<template>
  <div class="no_found">
    <section>
      <img src="./img/404.png" alt />
      <el-button type="primary" style="width:120px;margin-top:40px" @click='back'>返回首页</el-button>
    </section>
  </div>
</template>
<script>
export default {
    methods:{
        back(){
            this.$router.replace('/');
        }
    }
};
</script>
<style lang="less" scoped>
.no_found {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  >section {
      display: flex;
      flex-direction: column;
      align-items: center;
  }
}
</style>